// We are disabling turbo on forms by default unless we provide a data-turbo=true for specific forms
// This will help with the migration to Turbo especially while we keep UJS around.
Turbo.config.forms.mode = 'optin';

// When a turbo-frame response doesn't contain the expected frame (e.g. a redirect
// to a page using a different layout), fall back to a full-page navigation instead
// of showing Turbo's default "Content missing" message.
document.addEventListener("turbo:frame-missing", (event) => {
  const { detail: { response, visit } } = event;
  event.preventDefault();
  visit(response);
});
